<template lang="pug">
v-card.pa-10(shaped, outlined='')
  div.overline.mb-4 {{ label }}
  //- pre {{ value }}
  v-row(v-for="(key, i) in getKeys(json).sort()")
    v-col
      v-text-field(
        label="key",
        :value="key",
        @input="updateKey(json, key, $event)",
        :type="isArray(json) ? 'number': 'text'",
        @keyup.enter="updateKey(json, '', 'key' + i)"
       )
    v-col(cols="12", v-if="!isArray(json[key]) && typeof json[key] === 'object'")
      json-editor(v-model="json[key]", :label="label + '.' + key")
    v-col.d-flex
      div(style="flex-grow: inherit", v-if="typeof json[key] === 'string' || typeof json[key] === 'number' || typeof json[key] === 'boolean'")
        v-text-field(
          label="value",
          v-model="json[key]",
           @keydown.enter="$set(json, key, [$event.target.value])"
         )
      div(
        style="flex-grow: inherit",
        v-if="isArray(json[key])"
       )
        v-text-field(
          label="value",
          @input="json[key].length === 0 && $set(json, key, '')",
          @keydown.enter="json[key].push($event.target.value); $event.target.value = ''"
         )
        //- div(v-for="(item, i) in json[key]")
          v-chip(
            :close="true",
            @click:close="json[key].splice(i, 1)"
           ) {{ item }}
    v-col(cols="12", v-if="isArray(json[key])")
      v-chip.ma-5.mt-0(
        style="overflow: visible"
        v-for="(item, i) in json[key]"
        :close="true",
        @click:close="json[key].splice(i, 1)",
        v-if="typeof(item) !== 'object'"
       )
        v-text-field(:placeholder="`${label}.${key}[${i}]`", :label="`${label}.${key}[${i}]`", v-model="json[key][i]")
      //- v-col(v-for="(item, i) in json[key]")
      json-editor(v-for="(item, i) in json[key]", style="flex-grow: inherit", v-if="typeof(item) === 'object'", :label="`${label}.${key}[${i}]`", :value="json[key][i]")
      v-btn(v-if="isArray(json[key]) || typeof json[key] === 'string' || typeof json[key] === 'number' || typeof json[key] === 'boolean'", icon, @click="json[key] = {'':''}") {}
      v-btn(v-else, icon, @click="json[key] = ''") ~
</template>
<script>
export default {
  name: 'JsonEditor',
  props: {
    label: {
      type: String,
      default: 'Root'
    },
    value: {
      default: () => ({})
    }
  },
  data () {
    return {
      json: null
    }
  },
  watch: {
    json: {
      deep: true,
      handler () {
        this.$emit('input', this.json)
      }
    },
    value:{
      handler(){
        this.json = this.value
      }
    }
  },
  methods: {
    isArray: (json) => Array.isArray(json),
    updateKey (json, key, $event, value = '') {
      if (this.isArray(json)) {
        if(Number(key) >= 0)
          return json.splice(Number(key), 1)
        else
          return json.push(value)
      }
      this.$set(json, $event, json[key] || '')
      this.$delete(json, key)
    },
    getKeys (object) {
      return Object.keys(object)
    },
    trySetJson (jsonString) {
      var json = { ...this.json }
      try {
        this.json = JSON.parse(jsonString)
      } catch {
        this.json = json
      }
    }
  },
  created () {
    console.log(this.json, this.value)
    this.json = this.value
  }
}
</script>